import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Progress broadcast

export interface GroupPostDetailFetchAction extends Action {
    readonly groupId: number;
    readonly postSlug: string;
}

/////////////////////////////////////////////////////////////////////
// Group post detail load
export const GROUP_POST_DETAIL_FETCH_TRIGGER = "GROUP_POST_DETAIL_FETCH_TRIGGER";
export interface GroupPostDetailFetchTriggerAction extends GroupPostDetailFetchAction {
    readonly type: typeof GROUP_POST_DETAIL_FETCH_TRIGGER;
}
export const GROUP_POST_DETAIL_FETCH_REQUEST = "GROUP_POST_DETAIL_FETCH_REQUEST";
export interface GroupPostDetailFetchRequestAction
    extends GroupPostDetailFetchAction, APIRequestAction {
    readonly type: typeof GROUP_POST_DETAIL_FETCH_REQUEST;
}
export interface GroupPostDetailFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        group: number;
        post: number;
        comments: number[];
        moderators: number[];
        complaints: number[];
        memberships: number[];
    };
}
export const GROUP_POST_DETAIL_FETCH_SUCCESS = "GROUP_POST_DETAIL_FETCH_SUCCESS";
export interface GroupPostDetailFetchSuccessAction
    extends GroupPostDetailFetchAction, APISuccessAction<GroupPostDetailFetchNormalizedResponse> {
    readonly type: typeof GROUP_POST_DETAIL_FETCH_SUCCESS;
}
export const GROUP_POST_DETAIL_FETCH_FAILURE = "GROUP_POST_DETAIL_FETCH_FAILURE";
export interface GroupPostDetailFetchFailureAction
    extends GroupPostDetailFetchAction, APIFailureAction {
    readonly type: typeof GROUP_POST_DETAIL_FETCH_FAILURE;
}

export const groupPostDetailFetchTrigger = (
    groupId: number,
    postSlug: string,
): GroupPostDetailFetchTriggerAction => ({
    type: GROUP_POST_DETAIL_FETCH_TRIGGER,
    groupId,
    postSlug,
});
export const groupPostDetailFetchApi = {
    request: (groupId: number, postSlug: string): GroupPostDetailFetchRequestAction => ({
        type: GROUP_POST_DETAIL_FETCH_REQUEST,
        groupId,
        postSlug,
    }),
    success: (
        groupId: number,
        postSlug: string,
        response: GroupPostDetailFetchNormalizedResponse,
    ): GroupPostDetailFetchSuccessAction => ({
        type: GROUP_POST_DETAIL_FETCH_SUCCESS,
        groupId,
        postSlug,
        response,
    }),
    failure: (
        groupId: number,
        postSlug: string,
        error: any,
    ): GroupPostDetailFetchFailureAction => ({
        type: GROUP_POST_DETAIL_FETCH_FAILURE,
        groupId,
        postSlug,
        error,
    }),
};
